<!--
Author: TangChen
Date: 2019-03-20
Desc: 空心圆图表组件，由index.js 配置引入
-->
<template>
    <div class="pie-art comp">
        <div :ref="refV + '-art'" style="height:100%;" />
    </div>
</template>
<script>
import echarts from "echarts/index.common";

export default {
    name: "PieArt",
    props: {
    // ref属性，用户重绘图表
        refV: {
            type: String,
            required: true
        },
        option: {
            type: Array,
            required: true
        },
        colors: {
            type: Array,
            default: () => {
                return ["#e99400", "#008cd4", "#48b75f", "#db2828", "#42b095", "#a750c7", "#75a85e", "#ea5b2f", "#ba9d43", "#2db0c8", "#5d62d3"];
            }
        }
    },
    data () {
        return {
            pieArt: null
        };
    },
    watch: {
    // 观察option的变化
        option () {
            this.initChart();
        }
    },
    mounted () {
        this.initChart();
    },
    beforeDestroy () {
        if (this.pieArt) this.pieArt.clear();
    },
    methods: {
    // 开始绘制图表
        initChart () {
            this.pieArt = echarts.init(this.$refs[this.refV + "-art"]);
            // 把配置和数据放这里
            this.pieArt.setOption({
                backgroundColor: "#ffffff",
                color: this.colors, // 颜色
                itemStyle: {
                    borderWidth: 2, // 设置border的宽度有多大
                    borderColor: "#fff"
                },
                series: [
                    {
                        name: "空心圆",
                        type: "pie",
                        radius: ["70%", "85%"], // 空心圆大小
                        center: ["45%", "50%"], // 圆心位置
                        hoverAnimation: false, // hover放大效果关闭
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: "center"
                            }
                        },
                        // 数据
                        data: this.option
                    }
                ]
            });
            this.resizeChart();
        },
        // 图表变化重绘
        resizeChart () {
            const _this = this;
            window.addEventListener("resize", () => {
                if (_this.pieArt) _this.pieArt.resize();
            });
        }
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  .pie-art {
  }
</style>
